import cn from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import Apps from '@mui/icons-material/Apps';
import styled from 'styled-components';
import { Spinner } from '../../../components/core';
import { useClickOutside } from '../../../util/useClickOutside';
import { AppIcons } from './app-icons/AppIcons';
import style from './style';
import MenuIcon from '../menu-icon/MenuIcon';
import ResponsiveSlide from './ResponsiveSlide';

const Styled = styled.div`
  ${style}
`;

const DEFAULT_TITLE = 'App Tray';

export const AppSwitcher = ({
  onChange,
  userApps,
  isLoading,
  appContext,
  entityContext,
  parentAppMessages,
  userLocale,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handler = e => {
      if (isOpen && e.key === 'Escape') {
        setIsOpen(false);
      }
    };
    window.addEventListener('keydown', handler);
    return () => {
      window.removeEventListener('keydown', handler);
    };
  }, [isOpen]);

  const toggle = useCallback(() => {
    setIsOpen(s => !s);
  }, []);

  const ref = useClickOutside(() => setIsOpen(false));

  return (
    <>
      <Styled className={cn('app-switcher')} $apps={userApps} ref={ref}>
        <MenuIcon icon={Apps} onClick={toggle} active={isOpen} />
        <div
          className={cn('overlay', { open: isOpen })}
          onClick={() => {
            setIsOpen(false);
          }}
        />
        <div className={cn('menu-container')}>
          <ResponsiveSlide direction="up" in={isOpen} mountOnEnter unmountOnExit>
            <div className={cn('app-tray', { active: isOpen })}>
              <div className="app-tray-inner">
                <div className="tray-title">
                  <div className="tray-title-text">{parentAppMessages[userLocale]?.app_tray || DEFAULT_TITLE}</div>
                </div>
                <Spinner spin={isLoading}>
                  <AppIcons apps={userApps} onClick={onChange} appContext={appContext} entityContext={entityContext} />
                </Spinner>
              </div>
            </div>
          </ResponsiveSlide>
        </div>
      </Styled>
    </>
  );
};
